module.exports = __webpack_public_path__ + "img/default_img.9b1f1b68.png";